import React from 'react';

const PortfolioIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.5 5.5C8.5 4.94772 8.94772 4.5 9.5 4.5H17.5C18.0523 4.5 18.5 4.94772 18.5 5.5V13.2845H17.5V8.5C17.5 6.84315 16.1569 5.5 14.5 5.5H8.5ZM15.5 8.5V13.2845H12.4494C12.0309 13.2845 11.6567 13.024 11.5115 12.6315L10.7076 10.4589C10.272 9.28161 9.14939 8.5 7.89404 8.5H5.5C5.5 7.94772 5.94772 7.5 6.5 7.5H14.5C15.0523 7.5 15.5 7.94772 15.5 8.5ZM2.5 11.5C2.5 10.6115 2.88625 9.81321 3.5 9.26389V8.5C3.5 6.84315 4.84315 5.5 6.5 5.5C6.5 3.84315 7.84315 2.5 9.5 2.5H17.5C19.1569 2.5 20.5 3.84315 20.5 5.5V13.5521C21.0978 13.8979 21.5 14.5442 21.5 15.2845V19.5C21.5 21.1569 20.1569 22.5 18.5 22.5H5.5C3.84315 22.5 2.5 21.1569 2.5 19.5V11.5ZM4.5 11.5C4.5 10.9477 4.94771 10.5 5.5 10.5H7.89404C8.31249 10.5 8.68669 10.7605 8.8319 11.153L9.63577 13.3256C10.0714 14.5029 11.194 15.2845 12.4494 15.2845H19.5V19.5C19.5 20.0523 19.0523 20.5 18.5 20.5H5.5C4.94772 20.5 4.5 20.0523 4.5 19.5V11.5ZM6.5 16.8141C5.94772 16.8141 5.5 17.2618 5.5 17.8141C5.5 18.3664 5.94772 18.8141 6.5 18.8141H9.47827C10.0306 18.8141 10.4783 18.3664 10.4783 17.8141C10.4783 17.2618 10.0306 16.8141 9.47827 16.8141H6.5Z"
      fill="#27B0E0"
    />
  </svg>
);

export default PortfolioIcon;
